import { useEffect } from 'react';
import { createCopilotPayloadToExecuteCommand, triggerFileManagerImageGeneration, handleTextReplacement } from 'tinymce-plugins/hsgenandselect/utils';
import { canUpdateSelection } from 'tinymce-plugins/hscopilotcollaboration/utils';
import useClearCopilotActiveEditorOnModuleChange from 'ContentEditorUI/copilot/useClearCopilotActiveEditorOnModuleChange';

// @ts-ignore Untyped module
import { useBus } from '../context/Bus';
export function inpageCommandHandler(editor, command, commandType) {
  // Handle AI image gen command that doesn't go to copilot
  if ('id' in command && command.id === 'generateimage') {
    triggerFileManagerImageGeneration(editor);
    return;
  }
  const payload = createCopilotPayloadToExecuteCommand(editor, command, commandType);
  sendCommandToCopilotInContentEditorFromInpage(payload, editor);
}
const InpageCopilotCollabSessionManager = () => {
  const editorBus = useBus();
  useClearCopilotActiveEditorOnModuleChange();
  useEffect(() => {
    editorBus.on(`post:insertIntoRichText:inpage`, message => {
      var _window$tinymce;
      // @ts-ignore tinymce on window global
      const activeEditor = (_window$tinymce = window.tinymce) === null || _window$tinymce === void 0 ? void 0 : _window$tinymce.activeEditor;
      if (activeEditor && canUpdateSelection(activeEditor)) {
        handleTextReplacementForInpage(activeEditor, message.payload.text);
      }
    });
    return () => {
      editorBus.off(`post:insertIntoRichText:inpage`);
    };
  }, [editorBus]);
  return null;
};
export default InpageCopilotCollabSessionManager;
function handleTextReplacementForInpage(editor, generatedText) {
  handleTextReplacement(editor, generatedText);

  // Update the selection after inserting the text, as it will now be selected
  sendUpdateToCopilotInContentEditorFromInpage({
    hasFocus: true,
    hasSelection: true,
    currentSelection: generatedText
  }, editor.settings.bus);
}
export function createFocusOrSelectionHandlerWithBus(bus) {
  return ({
    hasFocus,
    hasSelection,
    currentSelection,
    precedingText,
    followingText,
    contentLanguage,
    editorContext
  }) => {
    sendUpdateToCopilotInContentEditorFromInpage({
      hasFocus,
      hasSelection,
      currentSelection,
      precedingText,
      followingText,
      contentLanguage,
      editorContext
    }, bus);
  };
}
function sendCommandToCopilotInContentEditorFromInpage(payload, editor) {
  editor.settings.bus.postMessage({
    action: 'copilot:send-copilot-command',
    payload
  });
}
function sendUpdateToCopilotInContentEditorFromInpage({
  hasFocus,
  hasSelection,
  currentSelection,
  precedingText,
  followingText,
  contentLanguage,
  editorContext
}, bus) {
  bus.postMessage({
    action: `copilot:update-tiny-mce-state`,
    payload: {
      hasFocus,
      hasSelection,
      currentSelection,
      precedingText,
      followingText,
      contentLanguage,
      editorContext
    }
  });
}